<template>
    <div class="StatCardRow">
        <template
            v-if="isLoading"
        >
            <RPBaseStatCard
                v-for="i in placeholderCount"
                :key="i"
                class="StatCardRow__placeholder"
                :status="status"
            />
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>
<script>
import stat from 'status';
import RPBaseStatCard from'./RPBaseStatCard.vue';

export default {
    name: 'RPStatCardRow',
    components: {
        RPBaseStatCard
    },
    props: {
        placeholderCount: {
            type: Number,
            default: 4
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },

    }
};
</script>
<style lang="scss">
    .StatCardRow {
    }
</style>
